<template>
  <b-container>
    <h1>Upcoming</h1>

    <div class="box">
      <div class="table-responsive mb-4">
        <table class="table b-table table-bordered table-hover">
          <thead class="thead-light">
            <tr>
              <th>Participant</th>
              <th>Date</th>
              <th>Time</th>
              <th>Location</th>
              <th>Status</th>
              <th>Contact</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="results.length === 0">
              <td class="text-center" colspan="6">
                <em>No meetings found!</em>
              </td>
            </tr>

            <tr v-for="meeting in results" :key="meeting.uuid">
              <td v-if="meeting.invitee.uuid === $auth.user().uuid">
                <a :href="`user/${meeting.inviter.uuid}`">
                  <img
                    class="rounded-circle img-profile mr-2"
                    :src="meeting.inviter.avatar"
                    :alt="`${meeting.inviter.first_name} ${meeting.inviter.last_name}`"
                  />{{ meeting.inviter.first_name }} {{ meeting.inviter.last_name }}
                </a>
              </td>

              <td v-if="meeting.inviter.uuid === $auth.user().uuid">
                <a :href="`user/${meeting.invitee.uuid}`">
                  <img
                    class="rounded-circle img-profile mr-2"
                    :src="meeting.invitee.avatar"
                    :alt="`${meeting.invitee.first_name} ${meeting.invitee.last_name}`"
                  />{{ meeting.invitee.first_name }} {{ meeting.invitee.last_name }}
                </a>
              </td>

              <td>{{ meeting.date }}</td>
              <td>{{ meeting.start_time }} to {{ meeting.end_time }}</td>
              <td>
                <span v-if="meeting.meeting_type === 'in-person'">
                  In-Person
                </span>

                <span v-if="meeting.meeting_type === 'remote'">
                  Remote
                </span>
              </td>
              <td>{{ meeting.status | capitalize }}</td>

              <td>
                <a
                  class="btn btn-primary btn-xs btn-block"
                  :href="formatEmailLink(meeting)"
                >
                  Contact
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <b-btn
          variant="secondary" size="sm"
          @click="setPage(page - 1)" :disabled="loading || page === 1"
        >
          Prev Page
        </b-btn>

        <span class="text-muted" v-if="!loading">
          Page {{ page }} of {{ totalPages }}
        </span>

        <span class="text-muted" v-if="loading">
          Loading
        </span>

        <b-btn
          variant="secondary" size="sm"
          @click="setPage(page + 1)" :disabled="loading || page === totalPages"
        >
          Next Page
        </b-btn>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'MeetingsList',
  data () {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      results: [],
    }
  },
  mounted () {
    this.load()
  },
  filters: {
    capitalize (value) {
      return value.charAt(0).toUpperCase() + value.substr(1)
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http
        .get('meetings/upcoming', {
          params: {
            page: this.page,
            page_count: 25,
          }
        })
        .then(
          (res) => {
            this.results = res.data.data
            this.totalPages = res.data.meta.last_page
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    setPage (newPage) {
      this.page = newPage
      this.load()
    },
    formatEmailLink (meeting) {
      let address = meeting.inviter_email
      if (meeting.inviter.uuid === this.$auth.user().uuid) {
        address = meeting.invitee_email
      }
      return `mailto:${address}`
    }
  }
}
</script>

<style scoped>
.img-profile { width: 24px; height: 24px; }
</style>
